import { Injectable } from '@angular/core';
import { sustentosModulo } from 'src/app/aplicaciones-modulos/sustentos/diccionarios/sustentosModulo';
import { ClaveValorModel } from '../models/claveValorModel';
import { Observable } from 'rxjs';
import { DocumentoModel } from '../models/documentoModel';
import { ResposeDocumentoModel } from '../models/responseDocumentoMode';
import { DocumentoPKModel } from '../models/documentoPKModel';
import { SelectedGridModel } from '../models/selectedGridModel';
import { SustentoDocModel } from '../models/sustentoDocModel';
import { ResponseTreeAfectModel } from '../models/responseTreeAfectModel';
import { ResponseTreeNodeModel } from '../models/responseTreeNodeModel';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
@Injectable({
  providedIn: 'root'
})
export class FacturaService {

  urlSustentos: string;
  diccionarioUrl: any;

  constructor(private _commom: CommonService,
    private _utilServices: UtilsService) {
    this.urlSustentos = this._utilServices.getSustentos();
    this.diccionarioUrl = sustentosModulo.url.sustentos;
  }

  getAnios(): Observable<ClaveValorModel[]> {
    return this._commom.peticionGetConHeader(this.urlSustentos + this.diccionarioUrl.anios);
  }

  getDocumento(data: DocumentoModel): Observable<ResposeDocumentoModel[]> {
    return this._commom.peticionPostConHeader(this.urlSustentos + this.diccionarioUrl.getDocumento, data);
  }

  postDocumento(data: DocumentoPKModel): Observable<SelectedGridModel>{
    return this._commom.peticionPostConHeader(this.urlSustentos + this.diccionarioUrl.postDocumento, data);
  }

  postDocumentTreeNode(data: DocumentoPKModel, documento:string):Observable<ResponseTreeNodeModel> {
    return this._commom.peticionPostConHeader(this.urlSustentos + this.diccionarioUrl.treeNode + documento, data);
  }

  postDocumentTreeAfec(data: DocumentoPKModel, documento:string):Observable<ResponseTreeAfectModel> {
    return this._commom.peticionPostConHeader(this.urlSustentos + this.diccionarioUrl.documentTreeAfec + documento, data);
  }

  uploadSustento(data:any, option:boolean, index: number) {
    return this._commom.peticionPostConHeader(this.urlSustentos + this.diccionarioUrl.uploadDoc + option +'&cantSustPago=0&indexSustento=' + index, data);
  }

  updateStatusDoc(data: SustentoDocModel, option:string) {
    return this._commom.peticionPutConHeader(this.urlSustentos + this.diccionarioUrl.updateStatusDoc + option, data);
  }

}
